import { APP_TOUR } from './Base';

export const onSaveStatusRequest = (params = {}, cb) => ({ params, cb, type: APP_TOUR.SAVE_STATUS_REQUEST });
export const onSaveStatusFailure = (errors = {}, cb) => ({ errors, cb, type: APP_TOUR.SAVE_STATUS_FAILURE });
export const onSaveStatusSuccess = (payload = {}, cb) => ({ payload, cb, type: APP_TOUR.SAVE_STATUS_SUCCESS });

export const onResetRequest = (payload = {}) => ({ payload, type: APP_SETTINGS.RESET_REQUEST });
